import { useContext, useEffect, useState } from 'react';
import {useTranslation, withTranslation} from 'react-i18next';
import { TFunction } from 'i18next';
import { FilterContext } from '../../../../../context/FilterProvider';
import SimpleSelector from '../../../../simpleSelector';
import ObrasAPI from '../../../../../services/APIObras';
import { Option } from '../../../../../types/Option';
import FILTER_TYPES from '../../../filterTypes';
import { filterMeaningfulOptions } from '../../../../../utils/filterMeaninglessOptions';

interface CustomCheckSelectorProps {
  filterType: string;
  t: TFunction<'translations'>;
}

interface SimpleSelectorOption {
  name?: string;
  nombre?: string;
}

const CustomSimpleSelector = ({ t, filterType }: CustomCheckSelectorProps) => {
  const filterContext = useContext(FilterContext);
  const [options, setOptions] = useState<Array<Option>>([]);
  const { i18n } = useTranslation();

  const NO_RESULTS: Option[] = [{ code: '', name: `${t('input.noResults')}` }];

  useEffect(() => {
    const api = ObrasAPI.getInstance();
    const getPromise = (): Promise<Option[]> => {
      switch (filterType) {
        case FILTER_TYPES.clientDesignerStatus:
        case FILTER_TYPES.workManagementStatus:
        case FILTER_TYPES.technicalAssistanceStatus:
          return api.getClientStatusMasters().then((results) => results.map((result) => ({
            code: result.code || String(result.id),
            name: result.nombre,
          })));
        case FILTER_TYPES.cde:
          return api.getCDE(t).then((results) => results.map((result) => ({
            code: String(result.code),
            name: result.name,
          })));
        default:
          return api.getContractStatus();
      }
    };

    if ([
      FILTER_TYPES.eligibility,
      FILTER_TYPES.gisExemption,
      FILTER_TYPES.gis,
      FILTER_TYPES.accionaDap,
      FILTER_TYPES.customerDap,
      FILTER_TYPES.cde,
    ].includes(filterType)) {
      setOptions([
        { code: 'true', name: t('filters.yes') },
        { code: 'false', name: t('filters.no') }
      ]);
    } else {
      getPromise()
        .then((results) => {
          results = filterMeaningfulOptions(results);
          results.sort((a: SimpleSelectorOption, b: SimpleSelectorOption) => (a.name || a.nombre || '').localeCompare(b.name || b.nombre || '', 'es', { sensitivity: 'base' }));
          setOptions(results.length ? results : NO_RESULTS);
        })
        .catch((error) => {
          console.log(error);
          setOptions([]);
        });
    }
  }, [i18n.language]);

  return (
    <>
      <SimpleSelector
        filterType={filterType}
        options={options}
        filterContext={filterContext}
        placeholder={t('filters.filtersPlaceHolder.select') as string}
      />
    </>
  );
};

export default withTranslation()(CustomSimpleSelector);
